<div class="container">
  <nav class="navigation">
    <li>
      <a href="/deals">DEALS</a>
    </li>
    <li>
      <a href="/best-sellers">BEST SELLERS</a>
    </li>
    <li>
      <a href="/collections">COLLECTIONS</a>
      <ul class="submenu">
        <li>
          <a href="/collections/cat-eye">CAT EYE</a>
        </li>
        <li>
          <a href="/collections/cosmic-cat-eye">COSMIC CAT EYE</a>
        </li>
        <li>
          <a href="/collections/velvet-cat-eye">VELVET CAT EYE</a>
        </li>
        <li>
          <a href="/collections/astro-flash">ASTRO FLASH</a>
        </li>
        <li>
          <a href="/collections/flash-glitter">FLASH GLITTER</a>
        </li>
        <li>
          <a href="/collections/velvet-magnet-gel">VELVET MAGNET GEL</a>
        </li>
        <li>
          <a href="/collections/magical-moments">MAGICAL MOMENTS</a>
        </li>
        <li>
          <a href="/collections/hard-rock-x-rcm">HARD ROCK X RCM</a>
        </li>
        <li>
          <a href="/collections/insta-chrome-pens">INSTA-CHROME PENS</a>
        </li>
        <li>
          <a href="/collections/the-luxe-life">THE LUXE LIFE</a>
        </li>
        <li>
          <a href="/collections/french-kiss">FRENCH KISS</a>
        </li>
        <li>
          <a href="/collections/kyoto-calling">KYOTO CALLING</a>
        </li>
        <li>
          <a href="/collections/amalfi-getaway">AMALFI GETAWAY</a>
        </li>
        <li>
          <a href="/collections/an-enchanting-affair">AN ENCHANTING AFFAIR</a>
        </li>
        <li>
          <a href="/collections/style-blooms">STYLE BLOOMS</a>
        </li>
        <li>
          <a href="/collections/hollywood-walk-of-fame-collection"
            >HOLLYWOOD WALK OF FAME COLLECTION</a
          >
        </li>
      </ul>
    </li>
    <li>
      <a href="/gel-polish/fortify-protect">GEL POLISH</a>
      <ul class="submenu">
        <li>
          <a href="/gel-polish/fortify-protect">FORTIFY & PROTECT</a>
        </li>
        <li>
          <a href="/gel-polish/cream-gel">CREAM GEL</a>
        </li>
        <li>
          <a href="/gel-polish/led-gel-polish">LED GEL POLISH</a>
        </li>
      </ul>
    </li>
    <li>
      <a href="/color-dip">COLOR DIP</a>
    </li>
    <li>
      <a href="/essentials">ESSENTIALS</a>
    </li>
    <li>
      <a href="/led-lights">LED LIGHTS</a>
    </li>
    <li>
      <a href="/kits">KITS</a>
    </li>
    <li class="isShowMore">
      <a href="/soft-gel">SOFT GEL</a>
    </li>
    <li class="isShowMore">
      <a href="/how-to">HOW TO</a>
    </li>
    <li class="isShowMore">
      <a href="/video">VIDEOS</a>
    </li>
    <li class="show-more">
      SHOW MORE
      <ul class="submenu">
        <li>
          <a href="/soft-gel">SOFT GEL</a>
        </li>
        <li>
          <a href="/how-to">HOW TO</a>
        </li>
        <li>
          <a href="/video">VIDEOS</a>
        </li>
      </ul>
    </li>
  </nav>
</div>

<style>
  a,
  li {
    text-decoration: none;
    color: var(--global);
    list-style: none;
    font-size: clamp(1.6rem, 1.35vw, 2rem);
    text-wrap: nowrap;
    cursor: pointer;
  }
  .container {
    width: 100%;
    max-width: 1350px;
  }
  .navigation {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    position: relative;
    margin-top: 2px;
  }
  .submenu {
    overflow: hidden;
    width: fit-content;
    height: 0;
    border-radius: 0 0 20px 20px;
    position: absolute;
    top: 100%;
    background-color: var(--orange-light);
    opacity: 0;
    transition: all 200ms ease;
    transform-origin: left;
  }
  .navigation li {
    border-bottom: 3px solid transparent;
  }
  .navigation li:hover > .submenu {
    padding: 3rem;
    height: fit-content;
    min-height: 100%;
    opacity: 1;
  }
  .navigation li:hover {
    border-bottom: 3px solid var(--global);
    transition: all 300ms ease;
    transform-origin: left;
  }
  .isShowMore {
    display: none;
  }
  @media (min-width: 1180px) {
    .isShowMore {
      display: initial;
    }
    .show-more {
      display: none;
    }
  }
  @media (min-width: 1620px) {
    a {
      font-size: 2.2rem;
    }
  }
</style>
